import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListAlatTransportasi } from "@/services/getData"

export default function MasterAlatTransportasiPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listAlatTransportasi"],
    queryFn: getListAlatTransportasi,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
